export default {
  message_center: '消息中心',
  message_admin: '消息接收管理',
  message_clear_unread: '清除未读',
  message_all: '全部',
  message_unread: '未读{0}',
  message_fault_notification: '故障通知',
  message_work_order_message: '工单消息',
  message_system_notification: '系统通知',
  message_untreated: '未处理',
  message_processed: '已处理',
  message_recovered: '已恢复',
  message_unrecovered: '未恢复',

  message_processed_all: '一键处理',
  message_reset_default: '恢复默认',
  message_reception_management: '消息接收管理',

  message_table_message_type: '消息类型',
  message_table_internal_message: '站内信',
  message_table_email: '邮箱',
  message_table_email_receiving_frequency: '邮箱消息接收频率',
  message_table_email_receiving_frequency1: '即刻通知：每一条新消息均会发送新的通知邮件',
  message_table_email_receiving_frequency2:
    '延迟通知：设定时间内最多只通知一次，如设置延迟24小时则24小时内只会发送一次通知邮件',
  message_table_email_receiving_frequency3:
    '推荐选择延迟通知并且设置一个合理稍长的时间间隔，避免过多邮件打扰。如果需要即刻通知请联系MBE管理员。',
  message_table_normal_warning: '设备的普通警告通知',
  message_table_important_warning: '设备的重要警告通知',
  message_table_serious_warning: '设备的严重警告通知',
  message_table_order_message: '工单消息',
  message_table_immediately_frequency: '即刻',
  message_table_repeat_delay: '延迟',
  message_table_repeat_delay_placeholder: '请选择延迟时间',
  message_table_description_title: '说明',
  message_table_description_content:
    '您可以为每类消息设置接收方式，建议您设置接收所有消息的站内信，防止消息遗漏造成损失。根据需要选择邮箱接收，避免过多消息打扰，尽快得知重要消息。',

  message_confirm_notice_title: '提示',
  message_confirm_clear_unread_content: '确定清除未读?',
  message_confirm_handle_one_content: '确定处理该通知?',
  message_confirm_handle_all_content: '确定全部处理?',
  message_confirm_reset_content: '确定恢复默认?',

  message_search: '搜索',
  message_search_tips1: '总共',
  message_search_tips2: '条搜索结果',
  message_search_unit: '条',
  message_search_result_detail_links: '进入详情 >',
  message_confirm_clear_unread_title: '提示',
  message_handle_loading: '处理中...',
  message_url_redirect: '跳转到',
};
